import { URLS } from '../../../constants';
import apiClient from '../../client';
const getSelectedBillingDataAPI = {
    getSelectedBillingData: ({ billingIds }: { billingIds: any }) =>
        apiClient.post(URLS.getSelectedBillingData, {
            data: {
                billingIds,
            },
        }),
    getOrganizationEmployee: () =>
        apiClient.post(URLS.getOrganizationEmployee, {
            data: {},
        }),
    sendToGateway: ({ claimIds }: { claimIds: any }) =>
        apiClient.post(URLS.sendGateway, {
            data: {
                claimIds,
            },
        }),
    changeClaimStatus: ({ claimId }: { claimId: any }) =>
        apiClient.post(URLS.changeClaimStatus, {
            data: {
                claimId,
            },
        }),
};
export default getSelectedBillingDataAPI;
